export default {
    "NEW_ERROR": "NEW_ERROR",
    "REMOVE_ERROR": "REMOVE_ERROR",
    "NEW_SUCCESS": "NEW_SUCCESS",
    "REMOVE_SUCCESS": "REMOVE_SUCCESS"
}